import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import LocaleStrings from "Languages";
import {  screenHeightLeftFromTop } from "Constants";
import BillingDetailsHeader from "./header/index";
import BillingDetailsSubheader from "./subheader/index";
import BillinghistoryTable from "./billinghistorytable/index";
var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class BillingDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {

  }



  render() {
    let {clientdataforbilling,deviceSize} = this.props;
    return (
      <>
      {clientdataforbilling && clientdataforbilling.length > 0 ? (
        <div className="panel-body scrollable-content"
        style={{ height: deviceSize.height - screenHeightLeftFromTop, padding:0 }}>
        <BillingDetailsHeader/>
        <BillingDetailsSubheader/>
        <BillinghistoryTable/>
       </div>
      ):(
        ''
      )}
     </>
    );
  }
}


function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    clientdataforbilling: state.clientdataforbilling
  };
}

export default connect(mapStateToProps, {})(BillingDetails);
